module.exports = __webpack_public_path__ + "img/w11-b1.c2876531.jpg";